var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMacOs(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.591,
    height: 24,
    viewBox: "0 0 20.591 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "iOS",
    d: "M14.751,0a5.667,5.667,0,0,1-1.2,3.943,5,5,0,0,1-3.6,1.886,4.419,4.419,0,0,1,1.2-3.771A5.206,5.206,0,0,1,14.751,0Zm4.286,20.571a9.53,9.53,0,0,0,1.543-2.914,5.292,5.292,0,0,1-.686-9.6,5.921,5.921,0,0,0-4.629-2.4,7.764,7.764,0,0,0-2.743.514,3.456,3.456,0,0,1-1.886.514,4.565,4.565,0,0,1-2.057-.514,6.879,6.879,0,0,0-2.571-.514A5.912,5.912,0,0,0,1.037,8.571c-1.714,2.743-1.371,7.714,1.371,12C3.437,22.286,4.808,24,6.522,24a2.9,2.9,0,0,0,1.714-.514,5.475,5.475,0,0,1,2.4-.514,5.475,5.475,0,0,1,2.4.514A3.308,3.308,0,0,0,14.751,24c1.714,0,3.257-1.886,4.286-3.429Z",
    transform: "translate(0.011)",
    fill: "#707070"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMacOs);
export default __webpack_public_path__ + "static/media/macOS.417895fb689482728b7ca51d8dccbcb6.svg";
export { ForwardRef as ReactComponent };